/**
 * The FontFamilies available out-of-the-box in React-PDF are described in the documentation here:
 * @see {@link https://react-pdf.org/fonts}
 *
 * and listed in the code in `node_modules/@react-pdf/font/lib/index.browser.cjs` as:
 * `var standard = ['Courier', 'Courier-Bold',...]`
 *
 * We restrict ourselves to the built-in fonts as we had issues with adding new fonts.
 *
 * Note: There appears to be a bug with version `@react-pdf/render@^3.4.4` where all fonts are rendered as Helvetica.
 * Also please ensure all font files are present on your local dev environment, and are not git lfs 0 byte placeholders.
 */
export enum FontFamily {
  Courier = 'Courier',
  CourierBold = 'Courier-Bold',
  CourierOblique = 'Courier-Oblique',
  CourierBoldOblique = 'Courier-BoldOblique',
  Helvetica = 'Helvetica',
  HelveticaBold = 'Helvetica-Bold',
  HelveticaOblique = 'Helvetica-Oblique',
  HelveticaBoldOblique = 'Helvetica-BoldOblique',
  TimesRoman = 'Times-Roman',
  TimesRomanBold = 'Times-Bold',
  TimesRomanItalic = 'Times-Italic',
  TimesRomanBoldItalic = 'Times-BoldItalic',
}
